module.exports = __webpack_public_path__ + "media/iconic/circle-x-d2784c9d.svg";